<template>
  <b-container id="questionnaireStoreContainer" class="mt-5 mb-5">
    <b-row>
      <div class="userLine">
        <span>{{ user.firstname }}</span>
        , voici votre pack myfo personnalisé
      </div>
    </b-row>
    <b-row class="mt-5">
      <div class="title">myfo conseil <span v-if="this.userScore">serenity</span><span v-else>expert</span></div>
    </b-row>
    <b-row class="mt-5">
      <div v-if="this.userScore">
        <CardSerenity />
      </div>
      <div v-else>
        <CardExpert />
      </div>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="10" md="6">
        <a href="/scanner/dashboard/credentials"><b-button class="mf_btn_purple">Agréger mon portefeuille</b-button></a>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <div class="packText">
        <div>Ce pack ne vous convient pas ?</div>
        <div>Pas de panique vous pourrez en changer plus tard</div>
      </div>
    </b-row>
  </b-container>
</template>
<script>
import CardSerenity from "./comps/CardSerenity.vue";
import CardExpert from "./comps/CardExpert.vue";
export default {
  props: ["user"],
  components: {
    CardSerenity,
    CardExpert,
  },
  data() {
    return {
      userScore: false, //true = serenity false = expert
    };
  },
  mounted() {
    // créer fonction changeant le true false de la variable userScore
    console.log(this.user);
  },
};
</script>
<style lang="scss">
@import "../../../../sass/_variables.scss";
#questionnaireStoreContainer {
  justify-content: center;
  .row {
    justify-content: center;
  }
  .userLine {
    color: $mf_ft_color_white;
    text-align: center;
    font: normal normal normal $mf_ft_size_subtitle Segoe UI;
    letter-spacing: 0px;
    span {
      color: $purple_color;
    }
  }
  .title {
    text-align: center;
    font: normal normal normal $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .questCard {
    text-align: center;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
    li {
      padding: 10px;
      text-align: left;
    }
    li::marker {
      color: $purple_color;
    }
  }
  .packText {
    text-align: center;
    font: italic normal normal $mf_ft_size_subtitle Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
}
</style>
